// @flow
import EventEmitter from 'eventemitter3';

const eventemitter3 = new EventEmitter();
const Emitter = {
  on: (event: string, fn: any) => eventemitter3.on(event, fn),
  once: (event: string, fn: any) => eventemitter3.once(event, fn),
  off: (event: string, fn: any) => eventemitter3.off(event, fn),
  emit: (event: string, fn: any) => eventemitter3.emit(event, fn)
};
Object.freeze(Emitter);

export default Emitter;

export const EVENT_KEY = {
  LOADING_PREVIEW_THEME_SETTING: 'LOADING_PREVIEW_THEME_SETTING',
  COMPLETE_PREVIEW_THEME_SETTING: 'COMPLETE_PREVIEW_THEME_SETTING',
  RELOAD_CSAT_ADMIN_APP_DISPLAY: 'RELOAD_CSAT_ADMIN_APP_DISPLAY',
  START_STANDARD_SEARCH_GUIDE_TOUR: 'START_STANDARD_SEARCH_GUIDE_TOUR',
  UPDATE_LOCAL_STORAGE: 'UPDATE_LOCAL_STORAGE',
  CLICK_IFRAME_VISUAL_EDITOR: 'CLICK_IFRAME_VISUAL_EDITOR',
  SAVE_EDITOR_STATE: 'SAVE_EDITOR_STATE',
  SELECT_NODE_TREE_CODE_EDITOR: 'SELECT_NODE_TREE_CODE_EDITOR',
  TRACK_USER_CLICK: 'TRACK_USER_CLICK',
  VALIDATE_WITH_AI: 'VALIDATE_WITH_AI',
  VALIDATION_COMPLETE: 'VALIDATION_COMPLETE',
};
